import { render, staticRenderFns } from "./CrosswordProperties.vue?vue&type=template&id=259cfcc2&scoped=true"
import script from "./CrosswordProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./CrosswordProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CrosswordProperties.vue?vue&type=style&index=0&id=259cfcc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259cfcc2",
  null
  
)

export default component.exports